<div [attr.data-testid]="props.testId || null">
  <ng-container #fieldComponent></ng-container>
</div>